/**
 * @prettier
 */
export const VIRTUALIZE_MODELS_THRESHOLD = 100
export const VIRTUALIZE_MODELS_ESTIMATE_SIZE = 71
export const VIRTUALIZE_JSON_SCHEMA_2020_12_ESTIMATE_SIZE = 48
export const VIRTUALIZE_MODELS_OVERSCAN = 5

export const VIRTUALIZE_OPERATIONS_THRESHOLD = 150
export const VIRTUALIZE_OPERATIONS_TAG_ESTIMATE_SIZE = 70
export const VIRTUALIZE_OPERATIONS_ESTIMATE_SIZE = 60
export const VIRTUALIZE_OPERATIONS_OVERSCAN = 3
